import isLocal from './isLocal';

export default function createSubdomainUrl(
  host: string,
  subdomain: string,
  path?: string,
) {
  if (!subdomain) {
    return 'Subdomain must be defined';
  }
  let suffix = path;
  if (path && path?.[0] !== '/') {
    suffix = '/' + suffix;
  }
  return `${
    isLocal(host)
      ? `http://${host}/mp/${subdomain}`
      : host.includes('staging')
      ? `https://${subdomain}.staging.mymarket.org`
      : `https://${subdomain}.mymarket.org`
  }${suffix ?? ''}`;
}
